import React, { useCallback, useState } from 'react'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { FacebookCircleIcon } from '@/atoms/Icons/FacebookCircleIcon'
import { InstagramIcon } from '@/atoms/Icons/InstagramIcon'
import { TwitterXIcon } from '@/atoms/Icons/TwitterXIcon'
// import { YouTubeIcon } from '@/atoms/Icons/YouTubeIcon'
import { ParagraphMD, ParagraphSM } from '@/atoms/Text'
import { ANGEL_STUDIOS_EMAIL_GROUP_ID } from '@/constants/email'
import { GFooterMD, GTitleLG, GTitleXXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { EmailCaptureFormInput } from '@/views/SignUpView/EmailCapture/EmailCaptureFormInput/EmailCaptureFormInput'
import { EmailModal } from '@/views/YoungWashingtonView/components/EmailModal'

export default function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleSubmit = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <footer className="bg-[#040A13] py-10 md:p-16">
      <div className="mx-auto w-full px-4 md:w-[90vw] md:max-w-[1200px]">
        <div className="flex flex-col gap-12 md:flex-row">
          <div className="w-full text-white md:w-1/2">
            <GTitleXXL className="hidden uppercase  md:block">Stay Connected</GTitleXXL>
            <ParagraphMD className="hidden text-pretty !font-roboto text-white md:block">
              By joining the Young Washington movement, you get the latest news, events, and updates as we march toward
              July 4, 2026.
            </ParagraphMD>
            <GTitleLG className="uppercase md:hidden">Stay Connected</GTitleLG>
            <ParagraphSM className="text-pretty !font-roboto md:hidden">
              By joining the Young Washington movement, you get the latest news, events, and updates as we march toward
              July 4, 2026.
            </ParagraphSM>
          </div>
          <div className="w-full md:w-1/2">
            <FlexColumn>
              <EmailCaptureFormInput
                position="young-washington-email-signup"
                subscriptionGroupId={ANGEL_STUDIOS_EMAIL_GROUP_ID} //TODO confirm how this works
                projectSlug="young-washington"
                placeholder="Enter your email..."
                formClassName="flex w-full gap-1"
                inputWrapperClassName={'w-full'}
                inputClassName="flex-1 rounded px-4 py-3 !font-roboto text-sm rounded-xl mr-4 w-full md:w-[326px] !text-black"
                onSubmit={handleSubmit}
              >
                <Button
                  variant={'white'}
                  outline={true}
                  size={'md'}
                  className={'mx-auto mt-4 w-full border-2 !font-roboto md:mt-0 md:w-fit'}
                  type="submit"
                >
                  Submit
                </Button>
              </EmailCaptureFormInput>
              <GFooterMD className="mt-8 text-pretty !font-roboto text-white md:mt-6">
                By providing your email address, you agree to receive communications related to this community,
                including updates, announcements, and important notices. We will not sell or share your email with third
                parties without your consent, except as required by law. You may unsubscribe or request removal at any
                time. Participation is subject to our{' '}
                <a href={'https://www.angel.com/legal/terms-of-use'} target={'_blank'} className={'underline'}>
                  Terms of Use
                </a>{' '}
                and{' '}
                <a href={'https://www.angel.com/legal/privacy'} target={'_blank'} className={'underline'}>
                  Privacy Policy
                </a>
                . Welcome to the Revolution!
              </GFooterMD>
              <div className="mb-4 mt-6 flex justify-start gap-4">
                <a
                  href="https://www.facebook.com/youngwashington"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-[#2E3B4D] text-white"
                  aria-label="Facebook"
                >
                  <FacebookCircleIcon color1={'white'} color2={'none'} size={24} />
                </a>
                <a
                  href="https://x.com/washingtonmovie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-[#2E3B4D] text-white"
                  aria-label="Facebook"
                >
                  <TwitterXIcon color={'white'} size={24} />
                </a>
                {/* <a
                  href="#"
                  className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-[#2E3B4D] text-white"
                  aria-label="Facebook"
                >
                  <YouTubeIcon color={'white'} size={24} />
                </a> */}
                <a
                  href="https://www.instagram.com/youngwashington"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-[#2E3B4D] text-white"
                  aria-label="Facebook"
                >
                  <InstagramIcon color={'white'} size={24} />
                </a>
              </div>
            </FlexColumn>
          </div>
        </div>
        <GFooterMD className={'text-white'}>
          Copyright © {new Date().getFullYear()} Angel Studios Inc. All Rights Reserved.
        </GFooterMD>
      </div>
      <EmailModal handleCloseModal={handleCloseModal} isModalOpen={isModalOpen} />
    </footer>
  )
}
